<div class="app-footer">
  <div class="app-footer__inner">
    <div class="app-footer-left">
      <span class="pl-2">Copyright 2019 - DashboardPack.com</span>
    </div>
    <div class="app-footer-right">
      <a class="btn btn-sm btn-primary mr-2" href="https://dashboardpack.com">Homepage</a>
    </div>
  </div>
</div>
